"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Date helper functions are the only methods
// allowed to import directly from any 3rd party date utility library.
// eslint-disable-next-line no-restricted-imports
var date_fns_1 = require("date-fns");
var en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
var da_1 = __importDefault(require("date-fns/locale/da"));
var en_US_1 = __importDefault(require("date-fns/locale/en-US"));
var de_1 = __importDefault(require("date-fns/locale/de"));
var es_1 = __importDefault(require("date-fns/locale/es"));
var pt_1 = __importDefault(require("date-fns/locale/pt"));
var fr_1 = __importDefault(require("date-fns/locale/fr"));
var it_1 = __importDefault(require("date-fns/locale/it"));
var pl_1 = __importDefault(require("date-fns/locale/pl"));
var nl_1 = __importDefault(require("date-fns/locale/nl"));
var fi_1 = __importDefault(require("date-fns/locale/fi"));
var languageToLocaleMap = {
    en: en_GB_1.default,
    da: da_1.default,
    us: en_US_1.default,
    de: de_1.default,
    es: es_1.default,
    pt: pt_1.default,
    fr: fr_1.default,
    it: it_1.default,
    pl: pl_1.default,
    nl: nl_1.default,
    fi: fi_1.default,
};
var DATE_FORMAT = 'dd/MM/yyyy';
var DATE_TIME_FORMAT = DATE_FORMAT + " HH:mm";
// Disabled since the parameter list has to match function in library
// eslint-disable-next-line max-params
function format(date, format, options) {
    try {
        return date_fns_1.format(date, format, options);
    }
    catch (err) {
        return 'Error parsing date';
    }
}
exports.parseDateTimeString = function (dateTime) { return date_fns_1.parseJSON(dateTime); };
exports.formatDateTime = function (dateTime, _a) {
    var _b = _a === void 0 ? { language: 'en' } : _a, language = _b.language, alternativeFormat = _b.alternativeFormat;
    return format(exports.parseDateTimeString(dateTime), alternativeFormat || DATE_TIME_FORMAT, {
        locale: languageToLocaleMap[language],
    });
};
exports.formatDate = function (date, _a) {
    var _b = _a === void 0 ? { language: 'en' } : _a, language = _b.language, alternativeFormat = _b.alternativeFormat;
    return format(date, alternativeFormat || DATE_FORMAT, {
        locale: languageToLocaleMap[language],
    });
};
exports.formatUnixTimestamp = function (unixTimestamp) {
    return format(date_fns_1.fromUnixTime(unixTimestamp), DATE_FORMAT);
};
exports.formatDuration = function (seconds) {
    if (seconds < 0) {
        return '-';
    }
    var hours = secondsToHours(seconds);
    var minutes = secondsToMinutes(seconds);
    var formattedHours = formatToTimeString(hours);
    var formattedMinutes = formatToTimeString(minutes);
    return formattedHours + ":" + formattedMinutes;
};
exports.formatSecondsToHMS = function (timeInSeconds) {
    if (timeInSeconds < 0) {
        return '-';
    }
    var hours = secondsToHours(timeInSeconds);
    var minutes = secondsToMinutes(timeInSeconds);
    var seconds = Math.floor(timeInSeconds % 60);
    var formattedHours = formatToTimeString(hours);
    var formattedMinutes = formatToTimeString(minutes);
    var formattedSeconds = formatToTimeString(seconds);
    return formattedHours + ":" + formattedMinutes + ":" + formattedSeconds;
};
function formatToTimeString(time) {
    return time.toString().padStart(2, '0');
}
function secondsToMinutes(seconds) {
    return ((seconds - (seconds % 60)) / 60) % 60;
}
function secondsToHours(seconds) {
    return (seconds - (seconds % 3600)) / 3600;
}
//# sourceMappingURL=date-formatter.js.map